export const APPRAISAL_REFRESH_MODULE = 'AppraisalRefreshModule';
export const COMPOSER_MODULE = 'CarvanaComposerUi';
export const SOFTPULL_MODULE = 'SoftPullModule';
